import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from 'utils/api';
export function fetchMindsetSettings() {
  return _fetchMindsetSettings.apply(this, arguments);
}
function _fetchMindsetSettings() {
  _fetchMindsetSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref,
      forceOnboardingPlan,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, forceOnboardingPlan = _ref.forceOnboardingPlan;
          return _context.abrupt("return", api('get', '/api/mindset/agent', {
            forceOnboardingPlan: forceOnboardingPlan
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchMindsetSettings.apply(this, arguments);
}
var MINDSET_SETTINGS_STALE_MS = 5 * 60 * 1000;
var mindsetSettingsCache = new Map();

// Avoids re-fetching agentUid on every surface (card, dock, login prefetch) mount.
// Cached by forceOnboardingPlan, since that can resolve to a different agentUid.
export function fetchCachedMindsetSettings() {
  var forceOnboardingPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var cached = mindsetSettingsCache.get(forceOnboardingPlan);
  if (cached && Date.now() - cached.fetchedAt < MINDSET_SETTINGS_STALE_MS) {
    return cached.promise;
  }
  var promise = fetchMindsetSettings({
    forceOnboardingPlan: forceOnboardingPlan
  }).then(function (settings) {
    // A user with no knowledge bank gets no agentUid, and stays that
    // way until they join a team that has one. Caching that would pin
    // every surface to "no agent" for the full stale window, so the
    // change wouldn't show without a page reload.
    if (!(settings !== null && settings !== void 0 && settings.agentUid)) {
      mindsetSettingsCache.delete(forceOnboardingPlan);
    }
    return settings;
  }).catch(function (error) {
    mindsetSettingsCache.delete(forceOnboardingPlan);
    throw error;
  });
  mindsetSettingsCache.set(forceOnboardingPlan, {
    promise: promise,
    fetchedAt: Date.now()
  });
  return promise;
}